<button
  #button
  (debounceClick)="onClickEvent()"
  [debounceTime]="debounceTime"
  dsDebounceClick
  class="btn"
  [ngClass]="['btn--' + variant, 'btn--' + size, 'btn--state-' + state, 'theme--' + environment, 'icon--' + iconPosition]"
  [class.btn--fullwidth]="fullwidth"
  [type]="type"
  [disabled]="disabled"
  [routerLink]="routerLink">
  <span [class.sr-only]="variant === 'icon-only'"> {{ label }} </span>
  <tngh-svg-icon
    *ngIf="iconName"
    [name]="iconName"
    [variant]="variant"
    [size]="iconSize">
  </tngh-svg-icon>
</button>
